
class PagedResultBase {
    currentPage: number;
    pageCount: number;
    pageSize: number;
    rowCount: number;

    constructor(currentPage: number, pageSize: number, rowCount: number) {
        this.currentPage = currentPage;
        this.pageSize = pageSize;
        this.rowCount = rowCount;
        this.pageCount = Math.ceil(rowCount / pageSize);
    }
}

export class PagedResult<T> extends PagedResultBase {
    results: T[];
    constructor(currentPage: number, pageSize: number, rowCount: number, data: T[]) {
        super(currentPage, pageSize, rowCount);
        this.results = data;
    }
}

export enum SORT_DIRECTION {
    ASC = 1,
    DESC = -1,
}

export interface SortingModel {
    column: string;
    direction: number;
}

export interface Pagination {
    pageNo: number;
    size: number;
}

export enum NOTIFICATION_MODE {
    POPUP = 'popup',
    BROWSER = 'browser'
}

export interface NtrNotification {
    id: string;
    title: NtrSupportedLanguages;
    subTitle: NtrSupportedLanguages;
    date: Date;
    link: string;
    snoozeDateTime?: Date,
    type: string;
    type_description?: NtrSupportedLanguages;
    additional_properties: NtrNotificationAdditionalProperties | undefined;
    external_key: string;
    user: string;
    sent: boolean;
    done: boolean;
    updated_date?: Date;
}

export interface NtrNotificationAdditionalProperties {
    mode: NOTIFICATION_MODE;
    color: string;
    svg: string;
    snoozeTime: Number[];
    closable: boolean;
    height?: number;
    width?: number;
    immediate?: boolean;
}

export interface NtrNotificationRequestModel {
    short_description: NtrSupportedLanguages;
    description: NtrSupportedLanguages;
    external_key: string;
    link?: string;
    type: string;
    users: string;
}

export interface NtrSupportedLanguages {
    en: string;
    it: string;
    de: string;
}

export interface NtrNotificationInterface {
    external_key: string;
    short_description: NtrSupportedLanguages;
    description: NtrSupportedLanguages;
    link?: string;
    type: string;
    user: string;
    sent: boolean;
    done: boolean;
    creation_date: Date;
    updated_date?: Date;
    snoozeDateTime?: Date,
}

export interface NtrSnoozeNotification {
    id: string;
    snoozeInMinutes: number;
}

export interface NtrNotificationType {
    type: string;
    description: NtrSupportedLanguages;
    additional_properties: NtrNotificationAdditionalProperties;
}

export enum NTR_FILTER_TYPE {
    SELECT = 'SELECT',
    TEXT = 'TEXT',
    DATE_RANGE = 'DATE_RANGE',
}

export enum NTR_FILTER_KEYS {
    USERS = 'users',
    TYPE = 'type',
    STATUS = 'status',
    FROM_TO = 'fromToDate',
    SHORT_DESCRIPTION = 'description',
}

export interface NtrFilter {
    key: NTR_FILTER_KEYS;
    type: NTR_FILTER_TYPE;
    column?: string;
    enabled: boolean;
    items?: {
        label: string;
        value: string;
    }[];
    selected?: string[] | string;
}

export enum SOURCE_TYPE {
    APPNOTIFIER = 'AppNotifier',
    MYTOOLS = 'MyTools'
}